<template>
  <div class="main">
    <div v-if="error !== null" class="message-container" role="alert">
      <span style="font-size: 20px; color: rgb(255, 108, 108)">{{ error }}</span>
    </div>
    <form class="form" style="min-height: var(--app-viewport-height);">
      <div class="fieldset">
        <div class="field field--text" style="--form-item-width:1;">
          <label class="field__label">Exportera utbetalning</label>
          <span class="valid" style="display: flex;">
            <button class="button action-button" @click.prevent="exportFile('sus')">SUS</button>
            <button class="button action-button" @click.prevent="exportFile('ska')">SKA</button>
          </span>
        </div>
        <div class="field field--text" style="--form-item-width:1;">
          <label class="field__label">Exportera utbetalning (ISO20022)</label>
          <span class="valid" style="display: flex;">
            <button class="button action-button" @click.prevent="exportFile('iso20022-net')">Netto ISO</button>
            <button class="button action-button" @click.prevent="exportFile('iso20022-tax')">Skatt ISO</button>
          </span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import fileDownload from 'js-file-download'

export default {
  name: 'payout-export',
  data() {
    return {
      error: null
    }
  },
  computed: {
    apiClient() {
      return this.$store.getters.api.trust(this.$route.params.trust)
    }
  },
  methods: {
    /**
     * @param {string} type sus, ska, iso20022-net, iso20022-tax
     */
    exportFile(type) {
      this.error = null

      let fileName = 'utbetalning.dat'
      switch (type) {
        case 'sus':
          fileName = 'utbetalning.sus'
          break
        case 'ska':
          fileName = 'utbetalning.ska'
          break
        case 'iso20022-net':
          fileName = 'utbetalning-netto.xml'
          break
        case 'iso20022-tax':
          fileName = 'utbetalning-skatt.xml'
          break
      }
      this.apiClient
        .payoutExport(type, this.$route.params.primaryKey)
        .then(resp => {
          if (resp.headers['content-disposition'] !== undefined) {
            fileName = resp.headers['content-disposition'].split('filename=')[1].replace(/['"]+/g, '')
          }
          fileDownload(resp.data, fileName)
          this.$router.go(-1)
        })
        .catch(err => {
          if (err.response) {
            const fr = new FileReader()
            fr.onload = () => {
              this.error = JSON.parse(fr.result).error
            }
            fr.readAsText(err.response.data)
          } else {
            this.error = err.message
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.message-container {
  top: calc(var(--navigation-total-height) + 1.5rem);
  left: 50%;
  position: fixed;
  z-index: 10;
  background-color: #012169;
  color: white;
  padding: 0.5rem 1.5rem;
  transform: translate(-50%, 0);
}
.action-button {
  background: var(--blue-dark);
  color: #fff;
  border-width: 0;
  padding: 1rem 1.5rem;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  margin-left: 0.5rem;
}
</style>
